import axios from "axios/dist/browser/axios.cjs";

// 创建axios实例
const request = axios.create({
  timeout: 10000, // 请求超时时间
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 自动添加token到请求头
    const token = localStorage.getItem("m-token");
    if (token) {
      config.headers["m-token"] = token;
    }
    return config;
  },
  (error) => {
    console.error("请求拦截器错误:", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 检查响应数据中的错误码
    const { data } = response;
    if (data && (data.code === 401 || data.code === 403)) {
      // token无效，清除本地存储并跳转登录页
      localStorage.removeItem("m-token");
      localStorage.removeItem("userInfo");
      window.location.href = "#/login";
      return Promise.reject(new Error(data.msg || "登录已过期，请重新登录"));
    }

    return response;
  },
  (error) => {
    console.error("响应拦截器错误:", error);

    // 处理HTTP状态码401/403错误
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      // 清除token
      localStorage.removeItem("m-token");
      localStorage.removeItem("userInfo");
      // 跳转到登录页
      window.location.href = "#/login";
    }

    return Promise.reject(error);
  }
);

export default request;
